module.exports = __webpack_public_path__ + "static/media/Info.8d2a723c.svg";